import {
  BulkActionContainerCol,
  Button,
  Col,
  Table,
  TableActionBarRow,
  ValueOrFallback,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  BulkActionCount,
  FormattedDate,
  ReportingMelcoMachineStatisticsModelsGroupListItem,
  Search,
  TableCellLink,
  useTableSelection,
} from "melco-shared-logic";
import { useMachineGroups } from "../../../../hooks/reporting/useMachineGroups";
import { BulkActionAddFilterMachineGroups } from "./BulkActionAddFilterMachineGroups";

export type FiltersMachineGroupsListProps = {
  machineGroupsFilter: any;
  setMachineGroupsFilter: any;
};

const DETAIL_VIEW_PATH = "/reporting/machine/groups";

export const FiltersMachineGroupsList: React.FC<
  FiltersMachineGroupsListProps
> = ({ machineGroupsFilter, setMachineGroupsFilter }) => {
  const { t } = useTranslation();
  const { data, pagination, onTableConfigChange, searchQueryChange } =
    useMachineGroups();

  const handleAddRemove = (
    obj: ReportingMelcoMachineStatisticsModelsGroupListItem
  ) => {
    if (isFilterAlreadyAdded(obj)) {
      setMachineGroupsFilter(
        machineGroupsFilter.filter(
          (selectedObj: any) => selectedObj.value !== obj?.id
        )
      );
    } else {
      setMachineGroupsFilter([
        ...machineGroupsFilter,
        { label: obj?.name, value: obj?.id },
      ]);
    }
    // setSelectedRowKeys([]);
  };
  // const isFilterAlreadyAdded = (name: string) => {
  //   return machineGroupsFilter?.find((c: any) => c.label == name);
  // };

  const isFilterAlreadyAdded = (obj: any) => {
    return machineGroupsFilter?.find((c: any) => c.value == obj.id);
  };

  const columns = [
    {
      title: t(
        "reporting.statistics.filters.machineGroup.add.list.columns.name"
      ),
      key: "name",
      sorter: true,
      render: (item: ReportingMelcoMachineStatisticsModelsGroupListItem) => (
        <ValueOrFallback
          value={item.name}
          render={(value) => (
            <TableCellLink to={[DETAIL_VIEW_PATH, item.id].join("/")}>
              {value}
            </TableCellLink>
          )}
          fallback={t("global.fallback.empty")}
        />
      ),
    },
    {
      title: t(
        "reporting.statistics.filters.machineGroup.add.list.columns.machines"
      ),
      key: "machine_count",
      dataIndex: "machine_count",
      sorter: true,
    },
    {
      title: t(
        "reporting.statistics.filters.machineGroup.add.list.columns.created"
      ),
      key: "created_date",
      dataIndex: "created_date",
      sorter: true,
      render: (
        _: string,
        item: ReportingMelcoMachineStatisticsModelsGroupListItem
      ) => <FormattedDate date={item.created_date} />,
    },
    {
      title: t(
        "reporting.statistics.filters.machineGroup.add.list.columns.last_modified"
      ),
      key: "updated_date",
      dataIndex: "updated_date",
      sorter: true,
      render: (
        _: string,
        item: ReportingMelcoMachineStatisticsModelsGroupListItem
      ) => <FormattedDate date={item.updated_date} />,
    },

    {
      title: "",
      render: (rowObj: ReportingMelcoMachineStatisticsModelsGroupListItem) => {
        return isFilterAlreadyAdded(rowObj ?? undefined) ? (
          <Button onClick={() => handleAddRemove(rowObj ?? undefined)}>
            {t(
              "reporting.statistics.filters.machineGroup.add.list.columns.deselect"
            )}
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={() => handleAddRemove(rowObj ?? undefined)}
          >
            {t(
              "reporting.statistics.filters.machineGroup.add.list.columns.select"
            )}
          </Button>
        );
      },
    },
  ];

  const { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow } =
    useTableSelection<ReportingMelcoMachineStatisticsModelsGroupListItem>(
      () => {}
    );

  return (
    <>
      <TableActionBarRow>
        <Col>
          <Search
            onSearchInputChange={(query: string) => searchQueryChange(query)}
          />
        </Col>
        <BulkActionContainerCol>
          <BulkActionCount selectedCount={selectedRowKeys.length} />
          <BulkActionAddFilterMachineGroups
            allMachineGroups={data}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            setMachineGroupsFilter={setMachineGroupsFilter}
            machineGroupsFilter={machineGroupsFilter}
          />
        </BulkActionContainerCol>
      </TableActionBarRow>

      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        pagination={pagination}
        onChange={onTableConfigChange}
        onRow={onRow}
        rowSelection={rowSelection}
        noDataMessage={t("reporting.machinegroups.list.empty")}
      />
    </>
  );
};
